import { LOAD_EMPTY_CART } from '../actionTypes/CartActionTypes';

export const loadEmptyCart = (payload) => ({
    type: LOAD_EMPTY_CART,
    payload,
});

export default { loadEmptyCart };
